import React from 'react';
import { connect } from 'react-redux';
import { deleteAbsenceSem } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Icon from '@mdi/react';
import { mdiShieldHalfFull } from '@mdi/js';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteAbsenceSem,
};

function ModalDeleteItem({ data, closeModal, deleteAbsenceSem }) {
  const { auth, history, item } = data;
  const classyear = item?.classyear;
  const kelasTitle = item?.kelasTitle;
  const yearTitle = item?.yearTitle;
  const semTitle = item?.semTitle;
  const absenceId = `${classyear.jenjang}-${classyear.kelas}-${classyear.year}-${classyear.sem}`;

  function onDelete() {
    deleteAbsenceSem({ auth, history, id: classyear.id, absenceId });
    closeModal();
  }

  return (
    <Modal closeModal={closeModal}>
      <div className='px-5'>
        <p className='has-text-info flex justify-start align-center is-size-5'>
          <span className='icon is-medium'>
            <Icon path={mdiShieldHalfFull} size={1} />
          </span>
          Konfirmasi
        </p>
        <div className='py-4 my-2 mx-2'>
          Apakah Anda yakin ingin menghapus semua absensi{' '}
          <span className='has-text-danger has-text-weight-semibold'>{`Kelas ${kelasTitle}`}</span>{' '}
          (TA {yearTitle}
          {' - semester '}
          {semTitle}) ?
          <div className='is-italic has-text-danger mt-2'>
            Note: Data yang dihapus tidak bisa dikembalikan
          </div>
        </div>
        <div className='flex justify-end align-center pt-2'>
          <div className='buttons'>
            <Button
              cvariant='cdelete'
              withLabel={true}
              onClick={() => onDelete()}
            />
            <Button cvariant='cback' withLabel={true} onClick={closeModal} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteItem);
